import React from 'react'
import GRADE_LEVELS from '../../../constants/grade-levels'
import { get, first } from 'lodash'
import { ExclamationCircleFill } from 'react-bootstrap-icons'

const GradeLevelRequirement = ({
    experience = {}
}) => {
    const gradeLevels = get(experience, 'gradeLevels', [])
    if (!gradeLevels.length || gradeLevels.length === Object.keys(GRADE_LEVELS).length) {
        return null
    }

    const gradeNames = gradeLevels.map( gradeLevel => {
        return first(Object.keys(GRADE_LEVELS).filter(key => GRADE_LEVELS[key] === gradeLevel))
    }).join(' / ')

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <ExclamationCircleFill />
            <strong style={{ paddingLeft: '10px' }}>{gradeNames} ONLY</strong>
        </div>
    )
}

export default GradeLevelRequirement